import {
  Answers,
  Application,
  Language,
  LocalizedInsuranceProduct,
  ProductsEntity,
  QuoteInfo,
} from '@breathelife/types';

import ApiService from './ApiService';

export async function getProducts(
  applicationId: string,
  answers: Answers,
  answersV2: Answers,
  lang?: Language,
): Promise<LocalizedInsuranceProduct[]> {
  const response = await ApiService.fetchProducts(applicationId, answers, answersV2, lang);
  return response.data;
}

export async function getProductsEntity(
  answers: Answers,
  answersV2: Answers,
  products: LocalizedInsuranceProduct[],
  quotes: QuoteInfo,
  application: Application,
): Promise<ProductsEntity<string>> {
  const response = await ApiService.getProductsEntity({ answers, answersV2, products, quotes, application });
  return response.data;
}
